import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
    {
        id: "po-06-h1v5-01",
        name: "PO 01 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 70, y: 128, width: 486, height: 303, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 438, width: 158, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 235, y: 438, width: 157, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 399, y: 438, width: 157, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 684, y: 230, width: 251, height: 323, rotation: 0, imageRotation: 0 },
            { id: "6", x: 943, y: 230, width: 251, height: 323, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-02",
        name: "PO 02 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 146, y: 155, width: 365, height: 511, rotation: 0, imageRotation: 0 },
            { id: "2", x: 703, y: 155, width: 181, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 415, width: 181, height: 251, rotation: 0, imageRotation: 0 },
            { id: "4", x: 892, y: 415, width: 180, height: 251, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 415, width: 180, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 892, y: 155, width: 368, height: 252, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "hs-06-h1v5-03",
        name: "HS 03 - H1V5",
        albumType: "HS",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 138, y: 148, width: 171, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 148, width: 170, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 138, y: 405, width: 349, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 148, width: 352, height: 488, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1031, y: 148, width: 172, height: 241, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1031, y: 396, width: 172, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-04",
        name: "PO 04 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 70, y: 176, width: 511, height: 293, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 70, y: 476, width: 122, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 200, y: 476, width: 122, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 476, width: 122, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 460, y: 476, width: 121, height: 170, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 176, width: 338, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-05",
        name: "PO 05 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 52, y: 203, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 395, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 191, y: 203, width: 596, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 794, y: 203, width: 266, height: 377, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1067, y: 203, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1067, y: 395, width: 132, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-06",
        name: "PO 06 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 52, y: 203, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 395, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 191, y: 203, width: 596, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 794, y: 203, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 794, y: 395, width: 132, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 933, y: 203, width: 265, height: 377, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-07",
        name: "PO 07 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 54, y: 213, width: 138, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 54, y: 415, width: 138, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 200, y: 213, width: 138, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 200, y: 415, width: 138, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 346, y: 213, width: 623, height: 395, rotation: 0, imageRotation: 0 },
            { id: "6", x: 977, y: 213, width: 277, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-08",
        name: "PO 08 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 244, width: 225, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 233, y: 244, width: 225, height: 333, rotation: 0, imageRotation: 0 },
            { id: "3", x: 466, y: 244, width: 494, height: 333, rotation: 0, imageRotation: 0 },
            { id: "4", x: 968, y: 244, width: 224, height: 333, rotation: 0, imageRotation: 0 },            
            { id: "5", x: 1200, y: 244, width: 111, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1200, y: 415, width: 111, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-09",
        name: "PO 09 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 243, y: 133, width: 890, height: 555, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 133, width: 195, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 40, y: 415, width: 195, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1141, y: 133, width: 130, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1141, y: 321, width: 130, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1141, y: 509, width: 130, height: 179, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-10",
        name: "PO 10 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
        size: [1311,820],
        style: {},
        slots: [
            { id: "1", x: 49, y: 157, width: 756, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 813, y: 157, width: 220, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1041, y: 157, width: 220, height: 301, rotation: 0, imageRotation: 0 },
            { id: "4", x: 813, y: 465, width: 145, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 966, y: 465, width: 145, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1119, y: 465, width: 144, height: 198, rotation: 0, imageRotation: 0 }
        ],
    }
];